import { createStore, compose, applyMiddleware } from "redux";
import * as axios from "axios";
import thunk from "redux-thunk";
import rootReducer from "./reducers/rootReducer";

/* request instance */
export const instance = axios.create({
  baseURL:
    process.env.NODE_ENV === "development"
      ? "http://pcappstore.loc/api/api.php"
      : "/api/api.php",
});
/* end request instance */

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

window.store = store;

export default store;
